





























































































import { Component, Vue, Prop } from "vue-property-decorator";
import CustomValueDisplay from "@/common/ui/components/CustomValueDisplay.vue";

@Component({
  components: {
    CustomValueDisplay
  }
})
export default class SalesSummaryNew extends Vue {
  @Prop({ required: true }) data!: any;
  @Prop({ required: true }) showVendor!: boolean;
  @Prop({ required: true }) vendorName!: boolean;

  tagName: string = "dd";
}
